"use client";
import useOpenCloseCashier from "@casino/client/components/CashierWrap/useCashier/useOpenCloseCashier";
import Button from "@casino/legacyUi/Button";
import type { CashierCurrencyType } from "@workspace/casino_core/schema";

type Props = {
  type: CashierCurrencyType;
  name: CashierCurrency;
};

const DepositToPlayButton: FC<Props> = ({ children, type, name }) => {
  const { handleOpen } = useOpenCloseCashier({
    type,
    name,
    cashierPath: "deposit",
  });
  return (
    <Button fullWidth variant="primary" size="xs" onClick={handleOpen}>
      {children}
    </Button>
  );
};

export default DepositToPlayButton;
